import {
  combineLatest as observableCombineLatest,
  of as observableOf,
  Observable,
  Subscription,
} from 'rxjs';

import {map} from 'rxjs/operators';
import {LanguageService} from '../language/language.service';
import {Title} from '@angular/platform-browser';
import {APPCONFIG} from '../config';
import {CacheService} from '../cache/cache.service';
import {UIConfiguration} from '../cache/uiconfiguration/uiconfiguration';

export class MyHistoryItem {
  public name: Observable<string>;

  constructor(
    public sitetype: string,
    public id: string,
    public id2: string,
    name: Observable<string>,
    attribute?: Observable<string>,
    languageResources?: Observable<string>,
  ) {
    if (sitetype == null) {
      console.error(
        'sitetype of new HistoryItem is null! (id: ' +
          id +
          ', id2: ' +
          id2 +
          ', name: ' +
          name +
          ')',
      );
    } else if (id == null) {
      console.error(
        'id of new HistoryItem is null! (sitetype: ' + sitetype,
        ', name: ' + name + ')',
      );
    }

    if (name == null) {
      name = observableOf(null);
    }

    if (attribute != null && languageResources != null) {
      this.name = observableCombineLatest(
        name,
        attribute,
        languageResources,
        (text: string, attr, lr) => {
          if (text == null || text.trim().length === 0) {
            if (attr == null) return '';
            return '⟨ ' + LanguageService.translate('DatatableNo', 'No', lr) + ' ' + attr + ' ⟩';
          } else {
            return text;
          }
        },
      );
    } else {
      this.name = name.pipe(
        map((text: string) => {
          if (text == null || text.trim().length === 0) {
            return '⟨ Unknown ⟩';
          } else {
            return text;
          }
        }),
      );
    }
  }
}

export class MyHistory {
  private _items: MyHistoryItem[];

  constructor(
    private titleService: Title,
    private cacheService: CacheService,
  ) {
    this._items = [];
  }

  clear() {
    this._items = [];
  }

  add(item: MyHistoryItem) {
    this._items.push(item);
    this.updateTitle();
  }

  replaceLast(item: MyHistoryItem) {
    if (this._items.length > 0) {
      this._items[this._items.length - 1] = item;
      this.updateTitle();
    } else {
      this.add(item);
    }
  }

  get items(): MyHistoryItem[] {
    return this._items;
  }

  removeAfterIndex(index: number) {
    this._items = this._items.slice(0, index);
    this.updateTitle();
  }

  removeLast() {
    this._items.pop();
    this.updateTitle();
  }

  isActive(index: number) {
    return index === this._items.length - 1;
  }

  get activeItem(): MyHistoryItem {
    if (this._items.length === 0) return null;
    return this._items[this._items.length - 1];
  }

  private nameSubscription: Subscription = null;

  updateTitle() {
    if (this.nameSubscription != null) this.nameSubscription.unsubscribe();
    const item = this.activeItem;
    this.cacheService.getUIConfiguration().subscribe((uiconf: UIConfiguration) => {
      if (item === null || item === undefined) {
        this.titleService.setTitle(uiconf.sitetitle);
      } else {
        this.nameSubscription = item.name.subscribe((text: string) => {
          if (text === null || text === undefined || text.trim().length === 0) {
            this.titleService.setTitle(uiconf.sitetitle);
          } else {
            this.titleService.setTitle(text + ' | ' + uiconf.sitetitle);
          }
        });
      }
    });
    //this.titleService.setTitle(APPCONFIG.pageTitle);
  }
}
